angular.module('bribac.views.singleSubject', [
  'ngRoute',
  'bribac.values',
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.entities.noteFactory',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.newMessageEditorModal',
  'bribac.services.showSamplesChartModal',
  'bribac.services.updateRuleSetEditFormat',
  'bribac.components.whenLoaded',
  'bribac.components.noteEditor',
  'bribac.components.collapsingBox',
  'bribac.components.subjectDetails',
  'bribac.components.ruleSetDetails',
  'bribac.components.schedulePeriodDetails',
  'bribac.components.testOverview',
  'bribac.components.testOverviewPopup',
  'bribac.components.newCalendar',
  'bribac.components.optionalSampleOverview',
  'bribac.components.whenLoaded',
  'bribac.components.inactiveDaysDetails',
  'bribac.services.newReportModal',
  'bribac.services.newTestOverviewPopup'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/subject/:id', {
      templateUrl: 'single-subject-view.html',
      controller: 'SingleSubjectViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('SingleSubjectViewCtrl', function(
    $routeParams,
    KINDS,
    noteFactory,
    api,
    state,
    newMessageEditorModal,
    showSamplesChartModal,
    updateRuleSetEditFormat,
    newReportModal,
    $uibModal,
    permissions,
    ROLES,
    FLAVOUR,
    CLAIMS
  ) {

    var $ctrl = this

    $ctrl.KINDS = KINDS
    $ctrl.permissions = permissions
    $ctrl.ROLES = ROLES;
    $ctrl.flavor = FLAVOUR;
    $ctrl.claimButtons = Object.values(CLAIMS);
    $ctrl.currentAgent = state.currentAgent;

    var subjectId = parseInt($routeParams.id)

    $ctrl.expandedTests = false
    $ctrl.expandedSamples = false

    $ctrl.startDate = null
    $ctrl.endDate = null

    var PHOTO_PLACEHOLDER = 'images/avatar.png'

    if (!isFinite(subjectId)) {
      // TODO: Should show 404 error instead. Should probably do this check in the $routeProvider config.
      return
    }

    /*
      Instant new test.
    */

    $ctrl.createImmediateTest = function() {
      if ($ctrl.creatingImmediateTest) {
        return
      }

      $ctrl.creatingImmediateTest = true
      $ctrl.actionSuccessI18n = ''
      $ctrl.actionErrorI18n = ''

      api.createImmediateTest(subjectId).then(
        function success(request) {
          $ctrl.subject.tests.unshift(request.data)
          $ctrl.creatingImmediateTest = false
          $ctrl.actionSuccessI18n = 'views.singleSubject.immediateTestSuccess'
        },
        actionErrorCallback
      )
    }

    $ctrl.resetPassword = function () {

      $ctrl.creatingImmediateTest = true
      $ctrl.actionSuccessI18n = ''
      $ctrl.actionErrorI18n = ''

      api.forgotPassword($ctrl.subject.email).then(
        function success(request) {
          $ctrl.creatingImmediateTest = false
          $ctrl.actionSuccessI18n = 'views.forgotPassword.resetEmailSentDescription'
        },
        actionErrorCallback
      )
    }

    function actionErrorCallback(request) {
      $ctrl.creatingImmediateTest = false
      $ctrl.actionErrorI18n = request.data.translationKey || request.data.statusText || 'Unknown error'
    }

    $ctrl.changeTestExpanded = function() {
      $ctrl.expandTestsPromise =
        getSubjectView(!$ctrl.expandedTests, $ctrl.expandedSamples)
    }

    $ctrl.fetchDataDynamic = function(d1, d2) {
      $ctrl.startDate = d1
      $ctrl.endDate = d2
      api.getSubjectViewWithDateRange('subject', subjectId, true, true, d1, d2).then(res => {
        delete res.data.images;
        $ctrl.subject.tests = res.data.tests
        $ctrl.subject.optionalAlcoholSamples = res.data.optionalAlcoholSamples
    })
    }

    let id=1000;

    $ctrl.reloadChild = function() {
      console.log("reloadchild parent");
      $ctrl.$broadcast('reloadChildEvent');
    };

    $ctrl.AAA = function() {
      console.log("XXXX click");
      var currentDate = new Date();
      var isoString = currentDate.toISOString();
      $ctrl.subject.tests.unshift({
        "id": id,
        "state": "EXPIRED",
        "bacLimitPassed": false,
        "geoFencePassed": false,
        "geoFence": null,
        "bacLimit": {
          "BRAC": 4.761904761904762,
          "BAC_PERCENT": 1,
          "BAC_PER_MILLE": 10
        },
        "immediate": true,
        "opensOnDate": isoString,
        "expiresOnDate": isoString,
        "sample": null
      });
      id++;
      $ctrl.actionSuccessI18n = 'views.singleSubject.immediateTestSuccess'
      // $ctrl.reloadChild();
    }

    $ctrl.changeSamplesExpanded = function() {
      $ctrl.expandSamplesPromise =
        getSubjectView($ctrl.expandedTests, !$ctrl.expandedSamples)
    }

    function getSubjectView(expandedTests, expandedSamples) {
     
      if ($ctrl.expandedTests === true || $ctrl.expandedSamples === true) {
        return api.getSubjectViewWithDateRange('subject', subjectId, expandedTests, expandedSamples, $ctrl.startDate, $ctrl.endDate)
        .then(function success(request) {
            $ctrl.subject.tests = request.data.tests
            $ctrl.subject.optionalAlcoholSamples = request.data.optionalAlcoholSamples
            $ctrl.expandedTests = false
            $ctrl.expandedSamples = false
    })
      }
      return api.getSubjectView('subject', subjectId, expandedTests, expandedSamples)
          .then(function success(request) { 
              $ctrl.subject.tests = request.data.tests
              $ctrl.subject.optionalAlcoholSamples = request.data.optionalAlcoholSamples
              $ctrl.expandedTests = true
              $ctrl.expandedSamples = true
      })
    }

    /*
      Send message.
    */

    $ctrl.newMessageEditorModal = function(subject) {
      newMessageEditorModal(subject, function saveSuccess(message) {
        $ctrl.subject.messages.unshift(message)
      })
    }

    /*
    Show modal samples chart
     */
    $ctrl.showSamplesChartModal = function(subject) {
      showSamplesChartModal(subject);
    };

    /*
      Add note.
    */
    function setNewNote() {
      $ctrl.newNote = noteFactory({
        author: {id: state.currentAgent.id},
        subject: {id: subjectId}
      })
    }

    $ctrl.showReportModal = function(subject) {
      newReportModal(subject,'subjectUsage', '.xls', true)
    }

    $ctrl.showSummaryReportModal = function(subject) {
      newReportModal(subject,'subjectSummaryReport', '.pdf', false)
    }

    setNewNote()

    $ctrl.handleAddNoteSubmit = function() {
      var $form = $ctrl.addNoteForm

      if ($form._submitting) return
      if ($form.$invalid) {
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $form._submitting = true
      $form._submitError = ''

      api.post(KINDS.NOTE, $ctrl.newNote)
        .finally(function() {
          $form._submitting = false
        })
        .then(
          function success(request) {
            $ctrl.subject.notes.push(request.data)
            $form.$setPristine()
            $form.$setUntouched()
            setNewNote()
          },

          function error(request) {
            $form._submitError = request.statusText
          }
        )
    }

    /*
      Edit note.
    */

    $ctrl.noteEditorData = {}
    $ctrl.noteEditForms = {}
    $ctrl.editNoteSubmitErrors = {}

    function setNoteEditorData(note, data) {
      if (!note) return
      var $form = $ctrl.noteEditForms[note.id]
      if ($form && $form._submitting) return
      $ctrl.noteEditorData[note.id] = data
    }

    $ctrl.editNote = function(note) {
      var editableNote = angular.copy(note)
      editableNote.subject = {id: $ctrl.subject.id}
      setNoteEditorData(note, editableNote)
    }

    $ctrl.cancelEditNote = function(note) {
      setNoteEditorData(note, null)
    }

    $ctrl.handleEditNoteSubmit = function(noteId) {
      var $form = $ctrl.noteEditForms[noteId]

      if ($form._submitting || $form.$invalid) {
        return
      }

      $form._submitting = true
      $ctrl.editNoteSubmitErrors[noteId] = ''

      api.put(KINDS.NOTE, $ctrl.noteEditorData[noteId]).then(
        function success(request) {
          $form._submitting = false
          $ctrl.subject.notes = $ctrl.subject.notes.map(function(note) {
            if (note.id === noteId) return request.data
            return note
          })
          $ctrl.noteEditorData[noteId] = null
        },

        function error(request) {
          $form._submitting = false
          $ctrl.editNoteSubmitErrors[noteId] = request.statusText
        }
      )
    }

    $ctrl.activation = function() {
      if ($ctrl.activating) {
        return
      }

      $ctrl.activating = true
      $ctrl.actionSuccessI18n = ''

      var data = angular.extend({}, $ctrl.subject);
      data.accountLocked = !$ctrl.subject.accountLocked

      data.ruleSet = updateRuleSetEditFormat(data.ruleSet)
      data.isPaused = data.accountLocked

      if (data.photos.length === 1 && data.photos[0].profileUrl === PHOTO_PLACEHOLDER) {
        data.photos = []
      }

      api['put'](KINDS.SUBJECT, data)
        .finally(function() {
          $ctrl.activating = false
        })
        .then(
          function success(request) {
            getSubjectView($ctrl.expandedTests, $ctrl.expandedSamples)
          },
          function error(request) {
            $ctrl.activationErrorI18n = (request.data && request.data.errorMessage)
              ? request.data.errorMessage
              : (request.statusText || 'Unknown error')
          }
        )
    }

    $ctrl.deleteSubject = function() {
      $ctrl.activating = true;
      if (confirm('Are you sure you want to delete this subject?')) {
        var data = angular.extend({}, $ctrl.subject);
        data.isDeleted = true
        data.ruleSet = updateRuleSetEditFormat(data.ruleSet)

        if (data.photos.length === 1 && data.photos[0].profileUrl === PHOTO_PLACEHOLDER) {
            data.photos = []
        }

        api.put(KINDS.SUBJECT, data)
        .then(function() {
          $uibModal.open({
            windowClass: 'modal-success',
            template: '<div class="modal-body">Subject ' +
              ($ctrl.subject.fullName || '') +
              ' (ID: ' + $ctrl.subject.id + ') deleted successfully.</div>',
            size: 'sm'
          });
          setTimeout(function() {
            window.location = '/#!/search';
          }, 2000);
        }, function(error) {
          $uibModal.open({
            windowClass: 'modal-danger',
            template: '<div class="modal-body">Error deleting subject ' +
              ($ctrl.subject.fullName || '') +
              ' (ID: ' + $ctrl.subject.id + '): ' +
              (error.data && error.data.errorMessage
                ? error.data.errorMessage
                : (error.statusText || 'Unknown error')) +
              '</div>',
            size: 'sm'
          });
        });
      }
      $ctrl.activating = false;
    };

    // Init
    $ctrl.viewPromise = api.getSubjectViewWithDateRange('subject', subjectId, true, true, $ctrl.startDat, $ctrl.endDate).then(function(request) {
      $ctrl.subject = request.data
      console.log("responseBackend: ", $ctrl.subject)
      if ($ctrl.subject.photos.length === 0) {
        $ctrl.subject.photos.push({
          profileUrl: PHOTO_PLACEHOLDER
        })
      }
      api.get(KINDS.ORGANIZATION, $ctrl.subject.organization.id).then(function(request) {
        $ctrl.organization = request.data
      })
    })

  })
